import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <div className="hills">
        <svg className='pricing-deco-img' enableBackground='new 0 0 300 100' height='300px' id='Layer_1' preserveAspectRatio='none' version='1.1' viewBox='0 0 300 100' width='100%' x='0px'  xlinkHref='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' y='60px'>
          <path className='deco-layer deco-layer--4' d='M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428&#x000A; c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z' fill='#E9908A' height='500px'></path>
        </svg>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/Hills.js